import { useBackendApi } from './backendApi';

export interface UpdateBusinessDaysConfigurationRequest {
  holidaysCountry?: string;
  excludeHolidays: boolean;
}

export interface BusinessDaysConfigurationDto {
  holidaysCountry?: string;
  excludeHolidays: boolean;
}

export function useBusinessDaysConfigurationService() {
  const nekstApi = useBackendApi();

  const getConfiguration = async (detailsFieldsSetId?: number): Promise<BusinessDaysConfigurationDto> => {
    let uri = '/businessdays/configuration';

    if (detailsFieldsSetId) {
      const params = { detailsFieldsSetId: detailsFieldsSetId.toString() };
      uri += '?' + new URLSearchParams(params);
    }

    return await nekstApi.get(uri) as BusinessDaysConfigurationDto;
  };

  const updateConfiguration = async (
    detailsFieldsSetId: number | undefined,
    request: UpdateBusinessDaysConfigurationRequest
  ): Promise<BusinessDaysConfigurationDto> => {
    let uri = '/businessdays/configuration';

    if (detailsFieldsSetId) {
      const params = { detailsFieldsSetId: detailsFieldsSetId.toString() };
      uri += '?' + new URLSearchParams(params);
    }

    return await nekstApi.put(uri, request) as BusinessDaysConfigurationDto;
  };

  return {
    getConfiguration,
    updateConfiguration,
  };
}
